import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrgUsersComponent } from "./org-users.component";
import { AlertMessageModule } from "../../lib/alert-message/alert-message.module";
import { AvatarIconModule } from "../avatar-icon/avatar-icon.module";
import { OrgUserComponent } from "./components/org-user/org-user.component";
import { AlertBannerModule } from "../../lib/alert-banner";
import { OrgUserRoleComponent } from "./components/org-user-role/org-user-role.component";
import { FormsModule } from "@angular/forms";
import { OrgEditRoleModalComponent } from "./components/org-edit-role-modal/org-edit-role-modal.component";
import { OrgInviteUserModalComponent } from "./components/org-invite-user-modal/org-invite-user-modal.component";
import { OrgInviteUserComponent } from "./components/org-invite-user/org-invite-user.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AppPaginationModule } from "../pagination/pagination.module";
import { SortModule } from "../sort/sort.module";
import { FilterUsersModule } from "../filter-users/filter-users.module";
import { SearchModule } from "../search/search.module"
import { EmailRegexValidatorModule } from "../../lib/email-regex-validator/email-regex-validator.module";
import { TooltipEllipsifyModule } from "../../directives/tooltip-ellipsify/tooltip-ellipsify.module";
import { LoaderModule } from '../loader/loader.module';
import { TooltipModule as BootstrapTooltipModule} from "ngx-bootstrap/tooltip";
import {
  BannerModule,
  ButtonModule,
  GroupDropdownModule,
  InputsModule,
  KebabMenuModule,
  ToggleModule,
  TooltipModule,
  CheckboxModule,
  RadioModule,
  DropdownModule,
  CardsModule,
  DynamicGroupDropdownModule
} from "@xref/xref-lib";
import {SortV2Module} from "../sort-v2/sort-v2.module";
import { OrgUserFilterModalComponent } from './components/org-user-filter-modal/org-user-filter-modal.component';
import { OrgRemoveUserModalComponent } from './components/org-remove-user-modal/org-remove-user-modal.component';
import { ManageSurveyPermissionsModalComponent } from './components/manage-survey-permissions-modal/manage-survey-permissions-modal.component';
import { ManageTeamsComponent } from './components/manage-teams/manage-teams.component';
import { NewInviteUserComponent } from './components/new-invite-user/new-invite-user.component';
import { UnsavedChangesComponent } from './components/unsaved-changes/unsaved-changes.component';
import { ManageConfirmModalComponent } from './components/manage-confirm-modal/manage-confirm-modal.component';
import { ResetMfaModalComponent } from './components/reset-mfa-modal/reset-mfa-modal.component';
import {OrgUserProfileModalModule} from "./components/org-user-profile-modal/org-user-profile-modal.module";

@NgModule({
  declarations: [
    OrgUsersComponent,
    OrgUserComponent,
    OrgUserRoleComponent,
    OrgEditRoleModalComponent,
    OrgInviteUserModalComponent,
    OrgRemoveUserModalComponent,
    OrgInviteUserComponent,
    OrgUserFilterModalComponent,
    ManageSurveyPermissionsModalComponent,
    ManageTeamsComponent,
    NewInviteUserComponent,
    UnsavedChangesComponent,
    ManageConfirmModalComponent,
    ResetMfaModalComponent
  ],
  imports: [
    CommonModule,
    AlertMessageModule,
    AvatarIconModule,
    AlertBannerModule,
    FormsModule,
    NgSelectModule,
    AlertModule.forRoot(),
    AppPaginationModule,
    SortModule,
    FilterUsersModule,
    SearchModule,
    EmailRegexValidatorModule,
    TooltipEllipsifyModule,
    TooltipModule,
    LoaderModule,
    ButtonModule,
    BootstrapTooltipModule.forRoot(),
    LoaderModule,
    InputsModule,
    SortV2Module,
    BannerModule,
    KebabMenuModule,
    ToggleModule,
    GroupDropdownModule,
    DynamicGroupDropdownModule,
    RadioModule,
    DropdownModule,
    CheckboxModule,
    CardsModule,
    OrgUserProfileModalModule
  ],
  exports: [OrgUsersComponent],
})
export class OrgUsersModule {
}
